
//Représente les paramètres de mise à jour de l’ordre des colonnes d’un utilisateur
export class ASeMettreAJourOrdreColonnesUtilisateurParametres 
{
  //Création
  constructor () 
  {
    this.identifiantsColonnes = [];
  }

  //Identifiant de l’onglet
  public identifiantOnglet!: string;

  //Identifiants des colonnes
  public identifiantsColonnes: string[];
}
